import { makeStyles } from '@material-ui/core/styles'

const usePaymentsStyles = makeStyles(theme => ({
  contentContainer: {
    margin: '2rem auto 6rem',
    maxWidth: 832,
    padding: theme.spacing(0, 2),
  },
  stack: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  navCard: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(2.5, 3),
    borderRadius: 12,
    backgroundColor: '#FFFFFF',
    border: '1px solid #E0E0E0',
    color: 'inherit',
    transition: 'background-color 0.2s ease, border-color 0.2s ease',
    '&:hover': {
      backgroundColor: '#FAFBFC',
      borderColor: '#D0D0D0',
    },
  },
  navIconWrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 40,
    height: 40,
    borderRadius: '50%',
    backgroundColor: '#EBF0F2',
    flexShrink: 0,
  },
  navIcon: {
    fontSize: 22,
    color: '#172024',
  },
  navCopy: {
    flex: '1 1 auto',
    minWidth: 0,
  },
  navTitle: {
    fontWeight: 700,
    fontSize: '0.9375rem',
    lineHeight: 1.3,
    color: '#00205B',
    marginBottom: theme.spacing(0.5),
  },
  navCaption: {
    fontSize: '0.8125rem',
    lineHeight: 1.4,
    color: theme.palette.text.secondary,
  },
  navChevron: {
    color: '#9EA7B0',
    flexShrink: 0,
  },
}))

export default usePaymentsStyles
